

































































import { LMap, LControlZoom, LMarker } from 'vue2-leaflet';
import Config from '@/models/config.model';
import Vue2LeafletGoogleMutant from 'vue2-leaflet-googlemutant';
import Marker from '@/models/marker.model';
import { DivIcon, Map } from 'leaflet';
import State from '@/classes/state';
import Place from '@/models/place.model';
import { getMarkerModifier, getMarkerMarkup } from '@/utility/map-utils';
import MapLegend from './MapLegend.vue';
import DealerList from './DealerList.vue';
import Dealer from '@/models/dealer.model';
import { DealerDetails } from '@/models/dealer-details.model';

export default {
    name: 'Map',
    components: {
        LMap,
        LControlZoom,
        LMarker,
        Vue2LeafletGoogleMutant,
        MapLegend,
        DealerList,
    },
    data() {
        const state: State = this.$store.state;

        return {
            config: state.config,
            translations: state.translations,
            mapContainer: null,
            mapOptions: {
                zoomControl: false,
            },
            scrollOverlayActive: false,
            scrollOverlayTimeoutId: null,
            dealerListId: 'dealer-search',
        };
    },
    computed: {
        myPlaceMarker(): Marker<void> | null {
            const myPlace = (this.$store.state as State).myPlace;

            if (!myPlace) {
                return null;
            }

            return {
                latLng: [myPlace.lat, myPlace.lng],
            };
        },
        markers(): Array<Marker<Dealer>> {
            const dealers = (this.$store.state as State).dealers;

            return dealers.map(dealer => {
                return {
                    latLng: [dealer.geometry.coordinates[1], dealer.geometry.coordinates[0]],
                    data: dealer,
                };
            });
        },
        markerCount(): number {
            return this.markers.length;
        },
        zoom(): number {
            return (this.$store.state as State).mapZoom;
        },
        minZoom(): number {
            const config: Config = this.config;
            const markerCount: number = this.markerCount;
            const currentZoom: number = this.zoom;

            if (markerCount >= config.map.maxMarkerCount) {
                // if current marker count exceeds maxMarkerCount
                // disable the zoom-out button so we don't show
                // more markers
                return currentZoom;
            }

            return config.map.minZoom;
        },
        center(): [number, number] {
            return (this.$store.state as State).mapCenter;
        },
        activeMarkerId(): string | null {
            return (this.$store.state as State).activeMarkerId;
        },
        activeDealerDetails(): DealerDetails | null {
            return (this.$store.state as State).activeDealerDetails;
        },
        dealerListOpen(): boolean {
            return (this.$store.state as State).dealerListOpen;
        },
    },
    watch: {
        activeMarkerId(
            newActiveMarkerId: string | null,
            prevActiveMarkerId: string | null
        ) : void {
            if (prevActiveMarkerId) {
                this.highlightMarkerElement(prevActiveMarkerId, false);
            }

            if (newActiveMarkerId) {
                this.highlightMarkerElement(newActiveMarkerId, true);
            }
        },
        activeDealerDetails(
            newActiveDealerDetails: DealerDetails | null,
            prevActiveDealerDetails: DealerDetails | null
        ): void {
            if (prevActiveDealerDetails) {
                this.highlightMarkerElement(prevActiveDealerDetails.dealer.id, false);
            }

            if (newActiveDealerDetails) {
                this.highlightMarkerElement(newActiveDealerDetails.dealer.id, true);
            }
        },
    },
    methods: {
        init() {
            this.mapContainer = this.$el.querySelector('#dealer-search-map');
            // console.log('mapContainer', this.mapContainer);
        },
        handleMapReady(map: Map): void  {
            // console.log('handleMapReady');
            this.$store.dispatch('setMap', map);
            this.$store.dispatch('setMapInitialized', true);
        },
        handleMapUpdateBounds(): void  {
            // console.log('handleMapUpdateBounds');
            this.$store.dispatch('loadDealersByMapBounds');
        },
        handleMapUpdateZoom(zoom: number): void  {
            // console.log('handleMapUpdateZoom', zoom);
            this.$store.dispatch('setMapZoom', zoom);
        },
        handleMapUpdateCenter(e: Place): void {
            // console.log('handleMapUpdateCenter', e);
            this.$store.dispatch('setMapCenter', {
                center: [e.lat, e.lng],
            });
        },
        createMyPlaceMarkerIcon(): DivIcon {
            const config: Config = this.config;

            return new DivIcon({
                className: 'mdl-dealer-search-marker mdl-dealer-search-marker--black',
                iconSize: config.leaflet.markerIconSize,
                iconAnchor: config.leaflet.iconAnchor,
                html: getMarkerMarkup('pin'),
            });
        },
        createDealerMarkerIcon(marker: Marker<Dealer>, index: number): DivIcon {
            const config: Config = this.config;
            const classnames = ['mdl-dealer-search-marker'];
            const markerData = marker.data;
            let markerId: string | undefined;  
            let centerFilter: string = "none"
            if (config.marker.centerFilter != '') centerFilter = config.marker.centerFilter

            if (markerData) {
                const cat2: string = markerData.properties.cat2
                //const { mapIconID } = markerData.properties;
                const markerModifier = getMarkerModifier((cat2.indexOf(centerFilter) > -1) ? 'center' : '');
                markerId = `marker-${markerData.id}`;
            
                if (markerModifier) {
                    classnames.push(markerModifier);
                }
            }

            return new DivIcon({
                className: classnames.join(' '),
                iconSize: config.leaflet.markerIconSize,
                iconAnchor: config.leaflet.iconAnchor,
                html: getMarkerMarkup('pin-solid', `${index + 1}`, markerId),
            });
        },
        handleMapWheel(e: WheelEvent): void  {
            if (e.ctrlKey || e.metaKey) {
                this.scrollOverlayActive = false;
                return;
            }

            e.stopPropagation();

            this.scrollOverlayActive = true;

            if (this.scrollOverlayTimeoutId) {
                clearTimeout(this.scrollOverlayTimeoutId);
                this.scrollOverlayTimeoutId = null;
            }

            this.scrollOverlayTimeoutId = setTimeout(() => {
                this.scrollOverlayActive = false;
            }, 1000);
        },
        handleDealerMarkerMouseEnter(marker: Marker<Dealer>): void {
            this.highlightMarker(marker, true);
        },
        handleDealerMarkerMouseLeave(marker: Marker<Dealer>): void {
            const activeDealerDetails: DealerDetails | null = this.activeDealerDetails;

            if (activeDealerDetails) {
                if (marker.data && activeDealerDetails.dealer.id === marker.data.id) {
                    // the user clicked the marker so it should stay highlighted
                    return;
                } else {
                    // the user left a different marker
                    // so the activeDealerDetails marker should
                    // be highlighted again
                    this.$store.dispatch('setActiveMarkerId', activeDealerDetails.dealer.id);
                }

                return;
            }

            this.highlightMarker(marker, false);
        },
        highlightMarker(marker: Marker<Dealer>, highlight: boolean) {
            const markerData = marker.data;

            if (!markerData) {
                return;
            }

            const dealerId = markerData.id;
            this.$store.dispatch('setActiveMarkerId', highlight ? dealerId : null);
        },
        /**
         * Highlights the marker with the given ID on the map
         */
        highlightMarkerElement(markerId: string, highlight: boolean): void {
            const markerInner = this.mapContainer.querySelector(`#marker-${markerId}`);
            
            if (!markerInner) {
                return;
            }

            const marker = markerInner.parentElement;
            
            if (!marker) {
                return;
            }

            marker.classList.toggle('mdl-dealer-search-marker--highlighted', highlight);
        },
        handleDealerMarkerClick(marker: Marker<Dealer>, index: number): void {
            const dealerDetails: DealerDetails = {
                dealer: marker.data as Dealer,
                marker,
                index
            };
            this.$store.dispatch('setDealerListOpen', true);
            this.$store.dispatch('setActiveMarkerId', marker.data?.id);
            this.$store.dispatch('setActiveDealerDetails', dealerDetails);
        },
        /**
         * This method is used
         * to update the marker index
         * in the dealer details view
         * after moving/zooming the map
         */
        updateActiveDealerDetailsMarkerIndex(): void {
            const activeDealerDetails: DealerDetails = this.activeDealerDetails;

            if (!activeDealerDetails) {
                return;
            }

            // if the dealer details are open
            // try to find the marker by
            // comparing the dealer IDs
            // to update the marker index
            // in the dealer details object
            const prevIndex = activeDealerDetails.index;
            let newIndex = -1;

            for (let i = 0, iLen = this.markers.length; i < iLen; i++) {
                const marker: Marker<Dealer> = this.markers[i];

                if (marker.data && marker.data.id === activeDealerDetails.dealer.id) {
                    // found the marker of the active dealer
                    newIndex = i;
                    break;
                }
            }

            if (prevIndex === newIndex) {
                return;
            }
        
            // index needs to be updated
            const dealerDetails: DealerDetails = {
                dealer: activeDealerDetails.dealer,
                marker: activeDealerDetails.marker,
                index: newIndex
            };

            this.$store.dispatch('setActiveDealerDetails', dealerDetails);
        },
        /**
         * Used to highlight the active marker
         * after map was moved/zoomed
         */
        highlightExistingActiveMarker(): void {
            if (this.activeMarkerId) {
                // highlight the active marker again
                // since the user probably
                // moved or zoomed the map
                this.highlightMarkerElement(this.activeMarkerId, true);
            }
        },
        handleToggleButtonClick() {
            this.$store.dispatch('setDealerListOpen', !this.dealerListOpen);
        },
    },
    mounted() {
        this.init();
    },
    updated() {
        this.highlightExistingActiveMarker();
        this.updateActiveDealerDetailsMarkerIndex();
    },
};
